import { render, staticRenderFns } from "./ProductListLoader.vue?vue&type=template&id=775e59e5&scoped=true&"
import script from "./ProductListLoader.vue?vue&type=script&lang=js&"
export * from "./ProductListLoader.vue?vue&type=script&lang=js&"
import style0 from "./ProductListLoader.vue?vue&type=style&index=0&id=775e59e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775e59e5",
  null
  
)

export default component.exports